import SHARED_ERRORS from "../shared/errors"
import SHARED_RESOURCE from "../shared/resource"
import SHARED_SCREENS from "../shared/screens"
import PORTAL_ERRORS from "./errors"
import PORTAL_NAVIGATION from "./navigation"
import PORTAL_SCREENS from "./screens"

export default {
  ...SHARED_RESOURCE,
  errors: { ...SHARED_ERRORS, ...PORTAL_ERRORS },
  navigation: PORTAL_NAVIGATION,
  screens: { ...SHARED_SCREENS, ...PORTAL_SCREENS },
} as const
